document.addEventListener('DOMContentLoaded', function () {
  // INCH / CM 切换
  const toggleInput = document.getElementById('unit-toggle-input');
  if (toggleInput) {
    toggleInput.addEventListener('change', function () {
      const isMetric = this.checked;
      document.querySelectorAll('.size-chart-table [data-inch]').forEach(cell => {
        cell.textContent = isMetric ? cell.dataset.cm : cell.dataset.inch;
      });
      document.getElementById('unit-inch').classList.toggle('active', !isMetric);
      document.getElementById('unit-cm').classList.toggle('active', isMetric);
    });
  }

  // 选中行高亮联动 Variant
  function highlightRow(selectedSize) {
    document.querySelectorAll('.size-chart-table tr[data-size]').forEach(row => {
      row.classList.toggle('highlighted', row.dataset.size === selectedSize);
    });
  }

  // 监听 Halo 主题 variant 变化
  document.addEventListener('theme:variant:change', function (e) {
    const size = e.detail?.variant?.option1;
    if (size) highlightRow(size);
  });

  // 备用监听
  document.addEventListener('variant:change', function (e) {
    const size = e.detail?.variant?.option1;
    if (size) highlightRow(size);
  });
});